import React from "react";
import { Link } from "react-router-dom";
import FrontendLayout from "../../components/frontend/FrontendLayout";

const Faq: React.FC = () => {
  return (
    <FrontendLayout>
      <section
        className="flat-title style-2 mb-4 tf-spacing-1"
        style={{ background: "#f9e7e4" }}
      >
        <div className="tf-container">
          <div className="row">
            <div className="col-lg-12">
              <div className="title-inner mb-0 pt-0 d-flex justify-content-between">
                <ul className="breadcrumb">
                  <li>
                    <Link to="/" className="home fw-6 text-color-3">
                      Home
                    </Link>
                  </li>
                  <li>FAQs</li>
                </ul>
                <h5 className="mt-3">FAQs</h5>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-faq tf-spacing-1">
        <div className="tf-container">
          <div className="row">
            <div className="col-xl-12 col-lg-12">
              <div className="heading-section mb-48">
                <h2 className="title">Frequently Asked Questions</h2>
              </div>
              <div className="tf-faq mb-49">
                <ul className="box-faq" id="wrapper-faq">
                  <li className="faq-item active">
                    <a
                      href="#accordion-faq-one"
                      className="faq-header h6 collapsed"
                      data-bs-toggle="collapse"
                      aria-expanded="true"
                      aria-controls="accordion-faq-one"
                    >
                      Why Should I Use Your Services? <i className="icon-CaretDown"></i>
                    </a>
                    <div
                      id="accordion-faq-one"
                      className="collapse show"
                      data-bs-parent="#wrapper-faq"
                    >
                      <p className="faq-body">
                        Once your account is set up and you've familiarized yourself with the
                        platform, you are ready to start using our services. Whether it's
                        accessing specific features, making transactions, or utilizing our tools,
                        you'll find everything you need at your fingertips.
                      </p>
                    </div>
                  </li>
                  <li className="faq-item">
                    <a
                      href="#accordion-faq-two"
                      className="faq-header h6 collapsed"
                      data-bs-toggle="collapse"
                      aria-expanded="false"
                      aria-controls="accordion-faq-two"
                    >
                      Why Should I Use Your Services? <i className="icon-CaretDown"></i>
                    </a>
                    <div
                      id="accordion-faq-two"
                      className="collapse"
                      data-bs-parent="#wrapper-faq"
                    >
                      <p className="faq-body">
                        Once your account is set up and you've familiarized yourself with the
                        platform, you are ready to start using our services. Whether it's
                        accessing specific features, making transactions, or utilizing our tools,
                        you'll find everything you need at your fingertips.
                      </p>
                    </div>
                  </li>
                  <li className="faq-item">
                    <a
                      href="#accordion-faq-three"
                      className="faq-header h6 collapsed"
                      data-bs-toggle="collapse"
                      aria-expanded="false"
                      aria-controls="accordion-faq-three"
                    >
                      How Secure Are Your Services? <i className="icon-CaretDown"></i>
                    </a>
                    <div
                      id="accordion-faq-three"
                      className="collapse"
                      data-bs-parent="#wrapper-faq"
                    >
                      <p className="faq-body">
                        Once your account is set up and you've familiarized yourself with the
                        platform, you are ready to start using our services. Whether it's
                        accessing specific features, making transactions, or utilizing our tools,
                        you'll find everything you need at your fingertips.
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </FrontendLayout>
  );
};

export default Faq;